// extracted by mini-css-extract-plugin
export default {"error_user":"GamePage_error_user__W4-v-"};